const makeSelectizeOnEach = require('../functions/makeSelectizeOnEach.js');
const isMobile = require('is-mobile');

module.exports = function () {
  const $tooltips = $('[data-toggle="tooltip"]');
  const $popovers = $('[data-toggle="popover"]');
  const $dataTables = $('.data-tables:not(.no-js)');

  $tooltips.length && $tooltips.tooltip();
  $popovers.length && $popovers.popover();

  !isMobile() && $dataTables.each(function (n, table) {
    let $table = $(table);

    if (!$table.hasClass('dataTable')) {
      $table.on('draw.dt', drawEvent);

      $table = $table.DataTable({
        paging: $table.hasClass('data-tables-paginate')
      });

      // $search.on('keyup', function(e) {
      //   $table.search(e.target.value).draw();
      // });
    }
  });

  $('.dataTables_paginate').each(function (n, el) {
    const $el = $(el);
    if ($el.find('.next.disabled,.previous.disabled').length === 2) {
      $el.addClass('hidden');
    }
  });

  makeSelectizeOnEach('.dynamic-select');
  makeSelectizeOnEach('[data-input="selectize"]');

  if (window.location.href.includes('settings')) {
    const hash = window.location.hash;
    const element = $(`.nav-tabs [href='${hash}']`).length ? $(`.nav-tabs [href='${hash}']`) : $(`.nav-tabs [data-bs-target='${hash}']`);

    // Corrige as tabs no settings quando redireciona para outra url com a hash de uma tab
    if (hash && element.length) {
      $('.nav-tabs .active').removeClass('active');
      element.addClass('active');
      element.parent().addClass('active');
      $('.tab-base').find('div.active').removeClass('active');
      $('.tab-base').find(hash).addClass('active show');
    }
  }
};

$('[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
  const $table = $(e.target).find('table');
  $table.length && $table.DataTable().columns.adjust();
});

$(function () {
  const hash = window.location.hash;
  const activeTab = $('.nav-tabs li.active a').attr('href');

  if (hash && hash != activeTab) {
    $('.nav-tabs .active').removeClass('active');
    $('[href="' + hash + '"]').parent().addClass('active');
  }
})

$('.nav-tabs li a').on('click', function (e) {
  $('.nav-tabs .active').removeClass('active');
  $(this).parent().addClass('active');
  e.preventDefault();
});

function drawEvent(e) {
  const $table = $(e.target);
  $table.data('fixedHeader') && $table.addClass('data-tables--fixed-header');
  $('.checkbox-cell > label').each(function (n, el) {
    $(el).niftyCheck();
  });
}

$('#tipoPagamento').on('change', function() {
  const tipoPagamento = $(this).val();
  const isUsed = ['', '2'].includes(tipoPagamento);
  $('#somenteTipoSelecionado').attr('disabled', isUsed);
  if (isUsed) {
    $('#somenteTipoSelecionado').closest('.form-checkbox').removeClass('active');
    $('#somenteTipoSelecionado').attr('checked', false);
  }
});
